// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .pucx-modal-close {
  display: none;
} */

:host ::ng-deep .p-dialog-mask  {
  z-index: 501 !important; /* Deixa o modal acima da pilha de modais criados pelo serviço */
}

:host ::ng-deep .pucx-message-content {
  font-size: 14px;
}

:host a,
:host a:hover,
:host a:visited {
  font-size: inherit;
}

:host ::ng-deep p-footer > div {
  padding: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/captcha/captcha.component.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,uBAAuB,EAAE,gEAAgE;AAC3F;;AAEA;EACE,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* .pucx-modal-close {\n  display: none;\n} */\n\n:host ::ng-deep .p-dialog-mask  {\n  z-index: 501 !important; /* Deixa o modal acima da pilha de modais criados pelo serviço */\n}\n\n:host ::ng-deep .pucx-message-content {\n  font-size: 14px;\n}\n\n:host a,\n:host a:hover,\n:host a:visited {\n  font-size: inherit;\n}\n\n:host ::ng-deep p-footer > div {\n  padding: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
